<script lang="ts" setup>
import { Clipboard } from 'v-clipboard'
import { ElMessage } from 'element-plus'
const props = defineProps<{
  content: string | number,
}>()
async function handleCopy() {
  try {
    await Clipboard.copy(props.content)
    ElMessage.success('复制成功')
  } catch (error) {
    ElMessage.error('复制失败，请重试')
  }
}
</script>

<template>
  <el-button link @click="handleCopy">
    <svg-icon name="copy" />
  </el-button>
</template>
